
import React from 'react';
import Row from '../Row';
import Col from '../Col';
import { downloadDocument } from '../../helpers/DownloadDoc';
import { getURLExtension, getFileTypeIcon } from '../../helpers/validationHelper';


const DownloadAttachment = ({
    fileURL,
    fileName,
    mainClass,
    subClass
}) => {
    const downloadAttachment = () => {
        downloadDocument(fileURL);
    }       
    const fileExtension = getURLExtension(fileURL);
    const fileIcon = getFileTypeIcon(fileExtension);
    return (
        <Row>
            <Col md={12} xs={12}>
                <div className={`downloadBox__${mainClass}`}>
                    <div className={`downloadBox__${subClass}`} style={{ padding: "10px" }}>
                        <div className='attachmentBox'><img src={`/assets/${fileIcon}`} alt='' /> <div className='attachmentBox__attachedText'>{fileName}</div></div>
                        <hr className='attachedline' />
                        <div className='downloadText' onClick={downloadAttachment}> <a> Download </a> </div>
                    </div>
                </div>
            </Col>
        </Row>
    )
}
export default DownloadAttachment